import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import cookies from 'js-cookie'
import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'
import 'animate.css'
import { axios } from '@/utils/request'
import '@/assets/styles/index.scss'
import '@/assets/css/interactions.css'
import FadeInUp from '@/components/FadeInUp.vue'
import FadeInUpGroup from '@/components/FadeInUpGroup.vue'

// Set up Vue prototypes
Vue.prototype.$cookies = cookies
Vue.prototype.axios = axios
Vue.prototype.Domain = 'http://admin.mentostelecom.com/mentos/download?id='

// Use plugins
Vue.use(ElementUI, { locale })
Vue.use(JsonViewer)

import GenericSearchContainer from "@/components/GenericSearchContainer.vue";
Vue.component('GenericSearchContainer', GenericSearchContainer);
Vue.component('FadeInUp', FadeInUp)
Vue.component('FadeInUpGroup', FadeInUpGroup)


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  var url = window.location.hash;
  if (url.match(/\?refresh-user=1$/)) {
    store.dispatch('refreshUserInfo')
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 应用启动时调用 API 验证登录状态（完全信任后端 cookie）
    this.$store.dispatch('refreshUserInfo')
  }
}).$mount('#app')
